// fetch cho createUploadLink: fetch thường không báo tiến độ upload. Chỉ khi operation truyền
// context.fetchOptions.onUploadProgress (vd upload file phiếu tư vấn) mới đi nhánh XMLHttpRequest;
// mọi request khác dùng fetch như cũ.

const abortError = () => {
  const error = new Error("The operation was aborted.");
  error.name = "AbortError";
  return error;
};

const parseHeaders = (raw) => {
  const map = {};
  (raw || "")
    .trim()
    .split(/[\r\n]+/)
    .forEach((line) => {
      const index = line.indexOf(":");
      if (index > 0) map[line.slice(0, index).trim().toLowerCase()] = line.slice(index + 1).trim();
    });
  return { get: (name) => map[String(name).toLowerCase()] ?? null, has: (name) => String(name).toLowerCase() in map };
};

export function xhrFetch(url, options = {}) {
  const { method = "POST", headers = {}, body, signal, onUploadProgress } = options;
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(abortError());
      return;
    }
    const xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    // Không tự đặt multipart Content-Type: trình duyệt tự thêm boundary cho FormData.
    Object.entries(headers).forEach(([name, value]) => {
      if (value !== undefined && value !== null) xhr.setRequestHeader(name, value);
    });
    if (options.credentials === "include") xhr.withCredentials = true;
    const onAbort = () => xhr.abort();
    signal?.addEventListener?.("abort", onAbort);
    const cleanup = () => signal?.removeEventListener?.("abort", onAbort);
    if (xhr.upload && onUploadProgress) {
      xhr.upload.onprogress = (event) =>
        onUploadProgress({ loaded: event.loaded, total: event.lengthComputable ? event.total : 0 });
    }
    xhr.onload = () => {
      cleanup();
      const text = xhr.responseText ?? "";
      resolve({
        ok: xhr.status >= 200 && xhr.status < 300,
        status: xhr.status,
        statusText: xhr.statusText,
        url,
        headers: parseHeaders(xhr.getAllResponseHeaders()),
        text: () => Promise.resolve(text),
        json: () => Promise.resolve(JSON.parse(text)),
      });
    };
    xhr.onerror = () => {
      cleanup();
      reject(new TypeError("Network request failed"));
    };
    xhr.onabort = () => {
      cleanup();
      reject(abortError());
    };
    xhr.send(body);
  });
}

export default function uploadProgressFetch(url, options = {}) {
  if (typeof options.onUploadProgress === "function") return xhrFetch(url, options);
  return fetch(url, options);
}
